var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleKeyboard',{attrs:{"modelValue":_vm.modelValue,"keyboard-class":"full-keyboard","staggered":"","placeholder":_vm.placeholder,"grab-focus":_vm.grabFocus},on:{"update:modelValue":_vm.emitValue}})}
var staticRenderFns = []

export { render, staticRenderFns }